import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Col,
  Form,
  FormControl,
  Row,
  Modal,
  Tab,
  Nav,
  Card,
  FormGroup,
} from "react-bootstrap";
import Select from "react-select";
import { counties_list } from "../Admin/AdminConstant";

import { IReduxState, IUserManagementReducer } from "../../utils/types";
import {
  changeUserCountriesActions,
  getSubUsersList,
} from "../../Redux/Actions/UserManagementActions";

const UserManagement = () => {
  const [whiteListCountries, setWhiteListCountries] = useState<any>([]);
  const [userOptionSelected, setUserOptionSelected] = useState<any>({});
  const [countriesSaveDisabled, setCountriesSaveDisabled] = useState(true);
  const dispatch = useDispatch();

  const UserManagementState = useSelector(
    (state: IReduxState) => state.UserManagement
  );

  useEffect(() => {
    dispatch(getSubUsersList());
  }, [dispatch]);

  let cfscId_list: any = [];
if (UserManagementState?.subUsersList?.users) {
  cfscId_list = UserManagementState.subUsersList.users.map((obj: any) => ({
    ...obj,
    value: obj._id,
    label: `${obj.name} | ${obj.email}`,
  }));
}

  let superUserCountries: any = [];
if (UserManagementState?.subUsersList?.countries && UserManagementState.subUsersList.countries.length>0) {
  superUserCountries = counties_list.filter((c: any) =>
    UserManagementState.subUsersList.countries.includes(c.code)
  );
}else{
  superUserCountries = counties_list;
}

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#5369f8" : "white",
      color: state.isFocused ? "white" : "black",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "black",
    }),
    control: (provided: any) => ({
      ...provided,
      // border: 'none',
      boxShadow: "none",
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: "none",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "gray",
    }),
  };

  const handleChangeUser = (selected: any) => {
    if (selected.countries && selected.countries.length > 0) {
      let selectedCountries = counties_list.filter((c: any) =>
        selected.countries.includes(c.code)
      );
      if (selectedCountries && selectedCountries.length > 0) {
        const tempSelectedCountries: any = [];
        selectedCountries.map((obj: any) => {
          return tempSelectedCountries.push({
            ...obj,
            value: obj.code,
            label: obj.name,
          });
        });
        setWhiteListCountries(tempSelectedCountries);
      } else {
        setWhiteListCountries([]);
      }
    } else {
      setWhiteListCountries([]);
    }

    setUserOptionSelected(selected);
  };

  const handleSaveUserCountries = () => {

    let country_code = whiteListCountries
      ? whiteListCountries.map((x: any) => x.value)
      : [];

    if (!arraysEqual(userOptionSelected.countries, country_code)) {
      dispatch(
        changeUserCountriesActions({
          id: userOptionSelected._id,
          countries: country_code,
        })
      );
      //dispatch(getUsersListAction());

      setCountriesSaveDisabled(true);
    }

    function arraysEqual(arr1: string | any[], arr2: string | any[]) {
      if (arr1.length !== arr2.length) return false;
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
      }
      return true;
    }
  };

  return (
    <>
      <Row className="d-flex justify-content-center mt-3">
        {" "}
        <Row>
          {" "}
          <h3 className="module_title">User Management</h3>{" "}
        </Row>{" "}
      </Row>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              <div className="d-flex flex-wrap flex-md-row flex-column justify-content-between button-row">
                <div className="d-flex flex-wrap justify-content-between flex-sm-row flex-column">
                  <Form.Group
                    as={Row}
                    className="mb-0"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "15px",
                    }}
                  >
                    <Form.Label
                      column
                      lg={4}
                      htmlFor="simpleinput"
                      id="smallerFontSize"
                    >
                      Select User:
                    </Form.Label>
                    <Col lg={8}>
                      <Select
                        className="react-select react-select-container fsz-875rem"
                        classNamePrefix="react-select"
                        // components={{ Option }}
                        styles={customStyles}
                        onChange={handleChangeUser}
                        name="users"
                        options={cfscId_list}
                        hideSelectedOptions={false}
                        // closeMenuOnSelect={true}
                        placeholder="Choose User"
                        defaultValue="Choose User"
                        value={userOptionSelected}
                        maxMenuHeight={100}
                      />
                    </Col>
                  </Form.Group>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Body>
              <Form.Group
                as={Row}
                className="mb-0"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "15px",
                }}
              >
                <Form.Label column lg={2}>
                  Countries Whitelist
                </Form.Label>
                <Col lg={10}>
                  <Select
                    isMulti={true}
                    options={superUserCountries.map((x: { code: any; name: any; }) => {
                      return { value: x.code, label: x.name };
                    })}
                    className="react-select react-select-container"
                    classNamePrefix="react-select"
                    onChange={(e) => {
                      setCountriesSaveDisabled(false);
                      setWhiteListCountries(e);
                    }}
                    value={whiteListCountries}
                  ></Select>
                </Col>
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className="transperent">
          <Card>
            <Card.Body>
              <Button
                style={{ margin: "0" }}
                variant="primary"
                onClick={() => handleSaveUserCountries()}
                disabled={countriesSaveDisabled}
              >
                Save
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default UserManagement;
